import { useSyncExternalStore } from "react";

import { assinarFila, lerFila, lerFilaVazia } from "./filaAtendimento";

const semAssinatura = () => () => {};

// `ativo=false` não assina: o KDS e quem não usa a fila não geram polling.
export function useFilaAtendimento(ativo = true) {
  return useSyncExternalStore(
    ativo ? assinarFila : semAssinatura,
    ativo ? lerFila : lerFilaVazia,
  );
}
